function d(...a) {
  var n;
  typeof window > "u" || !((n = window) !== null && n !== void 0 && (n = n.dataLayer) !== null && n !== void 0 && n.push) || window.dataLayer.push(arguments);
}
export {
  d as g
};
//# sourceMappingURL=index-DUTDaDpU.mjs.map
